import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';
import { passwordMatchValidator } from 'src/app/validators/confirm-password.validator';
import { ReCaptchaService } from '../../../services/recaptcha.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

    constructor(
        public loading: LoadingService,
        private http: HttpClient,
        private auth: AuthService,
        private title: Title,
        private toastr: ToastrService,
        private reCaptchaService: ReCaptchaService,
        private el: ElementRef) {
    }
    signupForm = new FormGroup({
        province_id: new FormControl(),
        city_id: new FormControl(),
        hospital: new FormControl(null),
        name: new FormControl(null),
        email: new FormControl(null, Validators.email),
        phone: new FormControl(null),
        str_number: new FormControl(null),
        profession: new FormControl(null),
        password: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/)]),
        password_confirmation: new FormControl(null),
        agree: new FormControl(null)
    }, { validators: passwordMatchValidator });
    provinceList: any[] = [];
    cityList: any[] = [];
    signUpDone = false;
    showPassword = false;

    async submitForm(signupForm: any): Promise<void> {
        if (!signupForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0].focus();
            return;
        }

        this.loading.start();
        signupForm.disable({ emitEvent: false });

        try {

            signupForm.value.agree = Number(signupForm.value.agree);
            const fdata = this.signupForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('fe_signup');
            const res = await this.auth.signUp({ ...fdata, token });

            signupForm.enable({ emitEvent: false });

            if (res) {
                this.signUpDone = true;
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    signupForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });
                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });

                return;
            }

            const title = res.response?.message || res.response?.description || 'Oops';
            const desc = res.response?.description || 'Error';
            this.toastr.error(desc, title);

        } catch (error) {
            signupForm.enable({ emitEvent: false });
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');
        } finally {
            this.loading.done();
        }
    }

    async getProvince(): Promise<void> {
        const data: any = await this.http.get(environment.apiUrl + '/provinces').toPromise();
        this.provinceList = data.result?.data;
    }

    async getCity(province_id: any): Promise<void> {
        const data: any = await this.http.get(environment.apiUrl + '/cities/' + province_id).toPromise();
        this.cityList = data.result?.data;
    }

    ngOnInit(): void {
        this.title.setTitle('Signup | MFGM');
        this.getProvince();
    }
}
